import { CommandType } from './command-type.interface';

export const DOOR_LOCK: CommandType = {
  name: 'Door Lock',
  description: 'Lock or Unlock a Door',
  route: 'door-lock',
  category: 'Security & Access',
  order: 0,
  whitelist: [
    {
      proxy: 'relaysingle_doorlock_c4',
      commands: [
        {
          id: 0,
          command: 'CLOSE',
          icon: 'door-unlock'
        },
        {
          id: 1,
          command: 'OPEN',
          icon: 'door-lock'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/command-types/door-lock.type.ts